import { TransactionSpinner } from "./tips.transactions.styled";

interface TipsTransactionsLoaderProps {
  readonly size?: number;
}

export const TipsTransactionsLoader = (
  props: TipsTransactionsLoaderProps,
): JSX.Element => {
  return <TransactionSpinner $size={props.size ?? 40} aria-hidden="true" />;
};
